import React from "react";
import HerbTower from "./components/HerbTower";

function App() {
  return <HerbTower />;
}

export default App;
